import { Link } from 'react-router-dom';
import useMeta from '../hooks/useMeta';

export default function Error403() {
  useMeta('403 Adgang Nægtet - KnowHow GROUP', 'Du har ikke adgang til denne side.');

  return (
    <div className="min-h-[70vh] bg-white flex items-center justify-center px-6 py-16">
      <div className="max-w-md w-full text-center flex flex-col items-center gap-6">
        {/* Lock Icon */}
        <div className="w-20 h-20 bg-slate-50 border border-slate-100 flex items-center justify-center text-gold-500 text-3xl mb-2">
          <i className="fa-light fa-lock-keyhole" aria-hidden="true" />
        </div>
        
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-500">
          Fejl 403
        </span>
        
        <h1 className="text-3xl md:text-4xl font-bold text-navy-950 tracking-tight">
          Adgang nægtet
        </h1>
        
        <p className="text-slate-500 text-sm leading-relaxed">
          Du har ikke tilladelse til at tilgå denne ressource. Hvis du mener, at dette er en fejl, bedes du kontakte vores administrator.
        </p>
        
        <Link
          to="/"
          className="mt-4 px-8 py-4 bg-navy-900 text-white text-xs font-semibold uppercase tracking-wider rounded-none hover:bg-gold-500 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-gold-400"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
